import { ModalTemplateComponent } from './modal-template/modal-template.component'
import { DateFormatService, AnchorService } from 'dmmp-services'
import { Component, OnInit, Input, ViewChild } from '@angular/core'

@Component({
  selector: 'dmmp-general-programming',
  templateUrl: './general-programming.component.html'
})
export class GeneralProgrammingComponent implements OnInit {

  @ViewChild(ModalTemplateComponent) localModalComponent = new ModalTemplateComponent()
  @Input() identifier
  @Input() campusTabs
  @Input() programInformation
  @Input() subEvents
  @Input() itemsOrder
  @Input() dateOrderGroup
  @Input() itemsPage = 8

  selectModel
  searchModel
  currentPage = 1
  totalPages = 1

  constructor(
    private dateFormatService: DateFormatService,
    private anchorService: AnchorService
  ) { }

  ngOnInit(): void {
    if (this.dateOrderGroup && this.dateOrderGroup.length > 0) {
      this.selectModel = this.dateOrderGroup[0]
    }
    if (this.campusTabs && this.campusTabs.length > 0) {
      this.filterEvents(this.campusTabs[0])
    }
  }

  filterEvents(tabIn) {
    this.currentPage = 1
    this.totalPages = 1
    this.searchModel = tabIn
    this.totalPages = Math.max(Math.ceil(this.subEvents.filter(item => {
      const tabs = item.campus.toString()
      return tabs.toLowerCase().includes(this.searchModel.label.toLowerCase()) && item.date.start >= this.selectModel.start
        && item.date.start <= this.selectModel.end
    }).length / this.itemsPage), 1)
  }

  newPageEvent(newPage) {
    if (this.programInformation?.id_element) {
      this.anchorService.scrollToId('#' + this.programInformation.id_element)
    } else {
      this.anchorService.scrollToId('#Programación_general_eventos')
    }
    this.currentPage = newPage.number
  }

  selectedEventNotification(event) {
    this.localModalComponent.selectedStartDate = this.dateFormatService.convertFromTimestampToDate(event.date.start)
    this.localModalComponent.selectedEndDate = this.dateFormatService.convertFromTimestampToDate(event.date.end)
    this.localModalComponent.temporalSelectedEvent = event
    this.localModalComponent.isModalOpen = true
  }

}
